
export module K9{
    export class SeatData{
        seat_pos:number;//服务器座位号
        player_id:number;//玩家id:
        cards:number[];
        card_type:number;//牌型
        card_point:number;//点数
        coin_balance:number;
        bet_coin:number;
        name:string;//玩家名字
        userJson:string;
        win_rate:number;//赢牌倍数
        balance:number;//抽水之前的值
        real_balance:number;//抽水之后的值
        state:PlayerState;
    }

    //庄家数据
    export class SeatBankData extends SeatData{
        banker_loop_cnt:number;//庄次数
    }

    export class CommonData{
        banker_queue:number[] = [];//庄家排队列表
        bankId:number;//庄家id
        ackId:number;//服务器的adc
        event:number;
    }

    //状态属于该阶段已经完成了
    export enum PlayerState{
        NoInGame=0,//未参与游戏
        isBegin = 1,//表示已经准备开始游戏的状态
        CheckBet = 2,//下注状态
        DealCards = 3,//表示发牌状态
        BeginOpen = 4,//预开牌状态
        Operator = 5,//示操作状态（可要牌）
        Settlement = 6,//结算
    }

    //游戏状态
    export enum GameState{
        None=0,//未参与
        isBegin = 1,//表示已经准备开始游戏的状态
        CheckBet = 2,//下注状态
        DealCards = 3,//表示发牌状态
        BeginOpen = 4,//预开牌状态
        Operator = 5,//示操作状态（可要牌）
        Settlement = 6,//结算
    }

    export enum CardType{
        Single=1,//单牌
        TongHua=2,//同花
        Sequence=3,///顺子
        Gzp=4,//公仔牌
        TongHuaSeq=5,//同花顺
        SanGong=6,//三公
        K8=7,//k8
        K9=8,//k9
    }

       //牌型显示
    export let PokerDes:{[k:number]:string} = {
        1:'pattern_1',//单牌//根据点数确定牌型
        2:'pattern_2',//同花
        3:'pattern_3',//顺子
        4:'pattern_4',//公仔牌
        5:'pattern_5',//同花顺
        6:'pattern_6',//三公
        7:'pattern_7',//k8
        8:'pattern_8',//k9
     } 

    export enum ActionTag{
        time=1,//倒计时时间
        chekBet=2,//下筹码
        FP=3,//翻牌
        DealCards=4,//发牌
        MoveBanker=5,//移动庄家
        dealTimes = 6,
        Obtain=7,
        guici1=8,
        Obtain1=9,
        step1=10,
        step2=11,
        step3=12,
        step4=13,
        overClear=14,
        overdelay=15,
        Three_FP = 16,
    }
    //下注筹码移动时间
    export let checkMoveTime = 0.2;
      //下注筹码间隔
    export let checkInterval = 0.02

    //池中获取筹码移动
    export let obtainMoveTime = 0.3;

    //池中获取筹码间隔
    export let obtainInterval = 0.05;

    //归池筹码移动时间
    export let guiChiMoveTime = 0.2;

    //归池筹码间隔
    export let guiChiInterval = 0.02;

}